module.exports = __webpack_public_path__ + "static/media/2-2.946118dc.png";